<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.brandSetupPanel.heading'"
    [ariaLabel]="'VisibilityIntelligence.brandSetupPanel.heading'"
    [responsiveWidth]="true"
    [minPanelWidth]="1150"
    [maxPanelWidth]="1150"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="agpr-viBrandSetupPanel">
        @if (hasViBrandSetups) {
            <div class="agpr-viBrandSetupPanel-mainPanel">
                <div class="agpr-viBrandSetupPanel-mainPanel-header">
                    <p class="agpr-viBrandSetupPanel-mainPanel-heading">
                        {{ 'VisibilityIntelligence.brandSetupPanel.message.heading' | localize }}
                    </p>
                    <p class="agpr-viBrandSetupPanel-mainPanel-subHeading">
                        {{ 'VisibilityIntelligence.brandSetupPanel.message.subHeading' | localize }}
                    </p>
                    @let questionsCount = monitor?.questions?.length ?? 0;
                    @if (questionsCount > 0) {
                        <agpr-message [severity]="severityEnum.warning" [bottomMargin]="false">
                            <p>{{ 'VisibilityIntelligence.brandSetupPanel.questionsWarning' | localize: { count: questionsCount } }}</p>
                        </agpr-message>
                    }
                </div>

                <div class="agpr-viBrandSetupPanel-mainPanel-columns">
                    <div class="agpr-viBrandSetupPanel-mainPanel-column-left">
                        <div class="agpr-viBrandSetupPanel-mainPanel-column-header">
                            <h4 class="agpr-viBrandSetupPanel-mainPanel-column-heading">
                                {{ 'VisibilityIntelligence.brandSetupPanel.mainPanel.brandHeading' | localize }}
                            </h4>
                        </div>
                        <agpr-scroll-panel #brandScrollPanel>
                            <div class="agpr-viBrandSetupPanel-mainPanel-cardList">
                                <agpr-vi-brand-identity-card
                                    [id]="id + '_brandCard'"
                                    [showExtendedFields]="true"
                                    [ngModel]="viBrand"
                                    (ngModelChange)="viBrand = $event"
                                    (brandSelected)="populateCompetitors($event)"
                                    [displayErrors]="displayErrors"
                                    [interactive]="false"
                                ></agpr-vi-brand-identity-card>
                            </div>
                        </agpr-scroll-panel>
                    </div>
                    <div class="agpr-viBrandSetupPanel-mainPanel-column-right">
                        <div class="agpr-viBrandSetupPanel-mainPanel-column-header">
                            <h4 class="agpr-viBrandSetupPanel-mainPanel-column-heading">
                                {{ 'VisibilityIntelligence.brandSetupPanel.mainPanel.competitorsHeading' | localize }}
                            </h4>
                            @if (isCompetitiveBenchmarking) {
                                <agpr-button
                                    [id]="id + '_addCompetitor'"
                                    [style]="buttonTypes.icon"
                                    icon="fa-regular fa-duotone fa-square-plus"
                                    tooltip="VisibilityIntelligence.brandSetupPanel.mainPanel.addCompetitor"
                                    (click)="addCompetitor()"
                                    [disabled]="viCompetitors.length >= maxCompetitors"
                                ></agpr-button>
                            }
                        </div>
                        <agpr-scroll-panel #competitorsScrollPanel>
                            <div class="agpr-viBrandSetupPanel-mainPanel-column-content">
                                <div class="agpr-viBrandSetupPanel-mainPanel-column-infoMessage">
                                    <agpr-message [severity]="severityEnum.info" [bottomMargin]="false">
                                        <p>{{ 'VisibilityIntelligence.competitorsSetupPanel.message' | localize }}</p>
                                    </agpr-message>
                                </div>

                                <div class="agpr-viBrandSetupPanel-mainPanel-field">
                                    <div class="agpr-viBrandSetupPanel-mainPanel-field-header">
                                        <label class="agpr-viBrandSetupPanel-mainPanel-field-label">
                                            {{ 'VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.label' | localize }}
                                        </label>
                                        <span
                                            role="img"
                                            class="fa-regular fa-circle-info agpr-viBrandSetupPanel-mainPanel-field-infoIcon"
                                            agprTooltip="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.tooltip"
                                            tooltipPosition="right"
                                        ></span>
                                    </div>
                                    <agpr-checkbox
                                        [id]="id + '_competitorBenchmarking'"
                                        label="VisibilityIntelligence.monitorSettingsPanel.competitorBenchmarking.enable"
                                        [binary]="true"
                                        [(ngModel)]="isCompetitiveBenchmarking"
                                    ></agpr-checkbox>
                                </div>

                                @if (isCompetitiveBenchmarking) {
                                    <div class="agpr-viBrandSetupPanel-mainPanel-cardList">
                                        @for (competitor of viCompetitors; track $index; let i = $index) {
                                            <agpr-vi-brand-identity-card
                                                [id]="id + '_competitorCard_' + i"
                                                [showExtendedFields]="false"
                                                [removable]="true"
                                                [excludedNames]="getExcludedNames(i)"
                                                [ngModel]="competitor"
                                                (ngModelChange)="viCompetitors[i] = $event"
                                                (removed)="removeCompetitor(i)"
                                                [displayErrors]="displayErrors"
                                            ></agpr-vi-brand-identity-card>
                                        }
                                    </div>
                                }

                            </div>
                        </agpr-scroll-panel>
                    </div>
                </div>
            </div>
        } @else {
            <agpr-scroll-panel>
                <div class="agpr-viBrandSetupPanel-startPanel">
                    <div class="agpr-viBrandSetupPanel-startPanel-header">
                        <span
                            role="img"
                            class="agpr-viBrandSetupPanel-startPanel-icon fa-kit-duotone fa-agpr-vi-monitor"
                            aria-hidden="true"
                        ></span>
                        <h3 class="agpr-viBrandSetupPanel-startPanel-heading">
                            {{ 'VisibilityIntelligence.brandSetupPanel.message.heading' | localize }}
                        </h3>
                        <p class="agpr-viBrandSetupPanel-startPanel-subHeading">
                            {{ 'VisibilityIntelligence.brandSetupPanel.message.subHeading' | localize }}
                        </p>
                        <p class="agpr-viBrandSetupPanel-startPanel-description">
                            {{ 'VisibilityIntelligence.brandSetupPanel.message.additionalText' | localize }}
                        </p>
                        <p class="agpr-viBrandSetupPanel-startPanel-prompt">
                            {{ 'VisibilityIntelligence.brandSetupPanel.message.prompt' | localize }}
                        </p>
                    </div>
                    <div class="agpr-viBrandSetupPanel-startPanel-brandIdentity-card">
                        <div class="agpr-viBrandSetupPanel-startPanel-brandIdentity-field">
                            <agpr-autocomplete
                                [id]="id + '_brand'"
                                class="agpr-viBrandSetupPanel-startPanel-brandIdentityAutocomplete"
                                [label]="'VisibilityIntelligence.brandSetupPanel.brandField.label'"
                                [placeholder]="'VisibilityIntelligence.brandSetupPanel.brandField.placeholder'"
                                [dropdown]="true"
                                [suggestions]="brandList$"
                                [customOptions]="selectedBrand ? brandListAutocompleteOptions : []"
                                [labelField]="'name'"
                                [(ngModel)]="selectedBrand"
                                (ngModelChange)="selectBrand($event)"
                                (searchStringChanged)="selectBrand($event)"
                                [forceSelection]="false"
                                [clearOnBlur]="false"
                                dropdownMode="current"
                            ></agpr-autocomplete>
                            <agpr-button
                                [id]="id + '_manageBrandIdentity'"
                                [style]="buttonTypes.block"
                                icon='fa-regular fa-duotone fa-gear'
                                tooltip="VisibilityIntelligence.brandSetupPanel.manageButton"
                                (click)="manageBrandIdentity()"
                            ></agpr-button>
                        </div>
                        <agpr-button
                            [id]="id + '_getStarted'"
                            class="agpr-viBrandSetupPanel-startPanel-brandIdentity-action"
                            [style]="buttonTypes.primary"
                            label="VisibilityIntelligence.brandSetupPanel.getStarted"
                            (click)="getStarted()"
                            [disabled]="!hasSelectedBrand"
                        ></agpr-button>
                    </div>
                </div>
            </agpr-scroll-panel>
        }
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancel'"
            [style]="buttonTypes.secondary"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        @if (hasViBrandSetups) {
            <agpr-button
                [id]="id + '_done'"
                [style]="buttonTypes.primary"
                label="done"
                (click)="done()"
            ></agpr-button>
        }
    </ng-template>
</agpr-take-over-panel>
